<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#consumer-layout-mobile {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
}
@supports (-webkit-touch-callout: none) {
  body.capacitor-ios html, body.capacitor-ios body {
    height: 100% !important;
    width: 100% !important;
    position: fixed !important;
    overflow: hidden !important;
  }
}
</style>
